import * as React from 'react';

import { getField } from 'utils/EntryUtil';
import { Image } from '../Image/Image';
import { Asset, Props as AssetProps } from './Asset';

type BaseImageProps = AssetProps<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>;

export type Props = Pick<BaseImageProps, Exclude<keyof BaseImageProps, 'src'>> & { offset?: number };

export class ContentfulImage extends Asset<HTMLImageElement, Props> {
  render() {
    const {
      autoWidth,
      autoHeight,
      imageHeight,
      imageWidth,
      fit,
      focus,
      asset,
      format,
      png8,
      offset,
      ...props
    } = this.props;
    if (!asset) {
      return null;
    }
    const file = getField(asset, 'file');
    const alt = getField(asset, 'description', '');
    const imageUrl = this.assetUrl || (file && file.url);
    return <Image src={imageUrl} alt={alt} dataAssetId={asset.sys.id} offset={offset} {...props} />;
  }
}
